let env = {};

env.baseURL = 'https://api.' + window.location.hostname + '/api/v1/'
env.normalURL = 'https://api.' + window.location.hostname + '/'
env.gptAuth = 'Bearer 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';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js